/**
 * Handles all network requests to the backend comparison endpoints.
 */
export async function compareGearSets(set1, set2, toggles) {
    try {
        const response = await fetch('/compare', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ set1, set2, toggles })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching comparison:', error);
        throw error;
    }
}

export async function fetchGearData() {
    try {
        const response = await fetch('/api/gear-data');
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching gear data:', error);
        throw error;
    }
}
